"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
var _canvasUiReact = require("@enterprise-ui/canvas-ui-react");
var _icons = _interopRequireWildcard(require("@enterprise-ui/icons"));
var IconExports = _icons;
var _commonUtilies = require("../../Utilis/commonUtilies");
require("../../styles/index.css");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
// import EnterpriseIcon, { HouseIcon, MenuIcon } from '@enterprise-ui/icons'

const {
  default: _default,
  EnterpriseIcon: _EnterpriseIcon,
  ...Icons
} = IconExports;
const defaultMenuItem = [{
  "name": "Home",
  "path": "/",
  "reload": true,
  "icon": /*#__PURE__*/_react.default.createElement(_icons.default, {
    icon: Icons['HouseIcon']
  }),
  "iconName": 'HouseIcon',
  "groups": []
}];
// const itemhubMenuForOtherApp = [ // New Sidenav Modifcation, so we Don't need the Backto itemhub Menu wit the menu array
//   {
//     name: 'Back to ItemHub',
//     path: '/',
//     reload: true,
//     icon: <EnterpriseIcon icon={Icons['ChevronLeftIcon']} />,
//     iconName: 'ChevronLeftIcon',
//     groups: [],
//   },
// ]

const menuCreate = (menus, startExpanded) => {
  return /*#__PURE__*/_react.default.createElement(_canvasUiReact.SideNav.Navigation, {
    "data-testid": "sideNavMainNavArea"
  }, menus.length !== 0 && menus.map((menu, index) => {
    let iconName = menu.iconName;
    return menu.groups.length === 0 ? menu.reload ? /*#__PURE__*/_react.default.createElement(_canvasUiReact.SideNav.NavigationItem, {
      as: "a",
      href: menu.path,
      className: ['menu-item font-weight-500', menu.path === '/' ? 'home-menu-reload' : ''].join(' '),
      selected: _commonUtilies.isItemHub && menu.path === '/',
      key: index
    }, /*#__PURE__*/_react.default.createElement(_icons.default, {
      icon: Icons["".concat(iconName)]
    }), " ", menu.name) : /*#__PURE__*/_react.default.createElement(_canvasUiReact.SideNav.NavigationItem, {
      as: _reactRouterDom.NavLink,
      to: menu.path,
      className: ['menu-item font-weight-500', menu.path === '/' ? 'home-menu' : 'other-menu'].join(' '),
      selected: false,
      key: index
    }, /*#__PURE__*/_react.default.createElement(_icons.default, {
      icon: Icons["".concat(iconName)]
    }), " ", menu.name) : /*#__PURE__*/_react.default.createElement(_canvasUiReact.SideNav.NavigationGroup, {
      startExpanded: startExpanded,
      className: "menu-items-group"
    }, /*#__PURE__*/_react.default.createElement(_canvasUiReact.SideNav.NavigationItem, {
      className: "menu-item font-weight-500 other-menu",
      style: menu !== null && menu !== void 0 && menu.path ? {
        textDecoration: 'none'
      } : {},
      as: menu !== null && menu !== void 0 && menu.path ? _reactRouterDom.NavLink : undefined,
      to: menu !== null && menu !== void 0 && menu.path ? menu.path : undefined,
      end: menu === null || menu === void 0 ? void 0 : menu.end
    }, /*#__PURE__*/_react.default.createElement(_icons.default, {
      icon: Icons["".concat(iconName)]
    }), " ", menu.name), /*#__PURE__*/_react.default.createElement(_canvasUiReact.SideNav.NavigationGroupContent, null, menu.groups.length !== 0 && menu.groups.map((groupItem, groupItemIndex) => {
      let groupIconName = groupItem.iconName;
      return /*#__PURE__*/_react.default.createElement(_canvasUiReact.SideNav.NavigationItem, {
        as: _reactRouterDom.NavLink,
        to: groupItem.path,
        key: groupItemIndex,
        className: "menu-item font-weight-500 menu-sub-item"
      }, /*#__PURE__*/_react.default.createElement(_icons.default, {
        icon: Icons["".concat(groupIconName)]
      }), " ", groupItem.name);
    })));
  }));
};
const SideNavigation = _ref => {
  let {
    canMinimize,
    isMinimized,
    isVisible,
    hideWhenMinimized,
    startExpanded,
    appMenus,
    displayAppName,
    ...otherProps
  } = _ref;
  // const displayDefaultMenu =
  //   window.location.pathname === '/' ? defaultMenuItem : itemhubMenuForOtherApp
  const displayDefaultMenu = window.location.pathname === '/' ? defaultMenuItem : []; // New Sidenav Modifcation, so we Don't need the Backto itemhub Menu wit the menu array
  const defaultMenu = otherProps.defaultmenurequired ? displayDefaultMenu : [];
  const menus = appMenus ? [...defaultMenu, ...appMenus] : defaultMenu;
  const [isSideNavOpen, setIsSideNavOpen] = (0, _react.useState)(true);
  const [isSideNavMinimized, setIsSideNavMinimized] = (0, _react.useState)(isMinimized | false);
  const handleSideNavToggle = () => {
    setIsSideNavOpen(!isSideNavOpen);
    console.log(isSideNavOpen);
  };
  const handleMinimizeNav = isSideNavOpenMini => {
    console.log('handleMinimizeNav', isSideNavMinimized);
    setIsSideNavMinimized(isSideNavOpenMini);
  };
  //   useEffect(() => {
  //     console.log('Do something after Sidenav has changed', isSideNavOpen);
  //  }, [isSideNavOpen]);

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_canvasUiReact.Button, {
    iconOnly: true,
    type: "ghost",
    "aria-label": "SideNav toggle Icon",
    onClick: () => {
      setIsSideNavOpen(!isSideNavOpen);
    },
    className: "sidenav-menubutton",
    style: {
      left: "13%",
      position: "absolute",
      zIndex: 10,
      top: 10,
      display: "none"
    }
  }, /*#__PURE__*/_react.default.createElement(_icons.default, {
    icon: Icons['MenuIcon']
  })), /*#__PURE__*/_react.default.createElement(_canvasUiReact.SideNav, {
    "data-testid": "sideNav",
    isVisible: isSideNavOpen
    // suppressAutoOpen={!isSideNavOpen}
    ,
    onRequestClose: () => {
      setIsSideNavOpen(isSideNavOpen);
    },
    isMinimized: isSideNavMinimized,
    canMinimize: isSideNavOpen,
    onMinimizeChange: minState => handleMinimizeNav(minState),
    className: (isSideNavOpen ? 'maximize-nav' : 'minimize-nav', 'sidenav-menu-lists iac-sidenav-component')
    // {...otherProps}
  }, /*#__PURE__*/_react.default.createElement(_canvasUiReact.SideNav.SkipLink, {
    "data-testid": "sideNavSkipLink",
    href: "#mainContent"
  }, "Skip to Main Content"), Boolean(_commonUtilies.isItemHub && (0, _commonUtilies.findApplicationName)()) && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("a", {
    href: "/",
    className: "active-link back-to-app",
    style: {
      padding: '10px'
    }
  }, /*#__PURE__*/_react.default.createElement(_icons.default, {
    icon: Icons['ChevronLeftIcon'],
    className: "back-to-app-icon"
  }), " ", !isSideNavMinimized && "Back to Itemhub"), /*#__PURE__*/_react.default.createElement(_canvasUiReact.Divider, {
    width: 10,
    style: {
      background: "#f6f7f8 !important"
    }
  }), !isSideNavMinimized && /*#__PURE__*/_react.default.createElement(_canvasUiReact.Heading, {
    size: 5,
    className: "display-app-name"
  }, displayAppName ? displayAppName : (0, _commonUtilies.findApplicationName)())), menuCreate(menus, startExpanded), (otherProps === null || otherProps === void 0 ? void 0 : otherProps.footerContent) && /*#__PURE__*/_react.default.createElement(_canvasUiReact.SideNav.Footer, null, otherProps.footerContent)));
};
var _default2 = exports.default = SideNavigation;